// src/components/FloatingWhatsApp.jsx
import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsApp = () => {

  // Updated WhatsApp number
  const ADMIN_WHATSAPP_NUMBER = "917771011010";

  const handleWhatsAppChat = () => {
    const currentPage = window.location.pathname;

    const message = `Hello MapYourCollege Team,
I visited your website  and I am interested in career counseling and college admissions guidance. Please share more details.`;

    const url = `https://wa.me/${ADMIN_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[100]">
      <button
        onClick={handleWhatsAppChat}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-transform hover:scale-110 flex items-center justify-center animate-bounce"
        title="Chat on WhatsApp"
      >
        <MessageCircle size={28} />
      </button>
    </div>
  );
};

export default FloatingWhatsApp;